import { register } from '@/calls/signup';
import { ApiFatalError, ApiInvalidParamError } from '@/errors/errors';
import {
  SIGNUP_FLOW_TYPE_EMAIL,
  SIGNUP_FLOW_TYPE_FACEBOOK,
} from '@/helpers/constants';
import FacebookAPI from '@/helpers/FacebookAPI';

const signup = {
  namespaced: true,
  state: {
    requests: 0,
    error: false,
    form: null,
    badParams: false,
    fieldsErrors: {},
    signupFlow: {
      type: SIGNUP_FLOW_TYPE_EMAIL,
      id: 0,
      email: '',
      name: '',
    },
    fields: {
      civility: '',
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      privacy: false,
      optin: false
    }
  },
  mutations: {
    setSignupFlow(state, data) {
        state.signupFlow = data;
    },
    setForm(state, el) {
      state.form = el;
    },
    updateField(state, { type, value }) {
      state.fields[type] = value;
    },
    setError(state, flag) {
      state.error = flag;
    },
    setBadParams(state, flag) {
      state.badParams = flag;
    },
    setFieldsErrors(state, object) {
      state.fieldsErrors = object;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    }
  },
  actions: {
    async emailRegister({ commit }) {
      commit('setSignupFlow', {
        type: SIGNUP_FLOW_TYPE_EMAIL,
        id: undefined,
        email: undefined,
        name: undefined
      });
      commit('updateField', { type: 'email', value: '' });
      commit('updateField', { type: 'firstname', value: '' });
    },
    async facebookRegister({ commit }) {
      const login = await FacebookAPI.login();

      if (login.status === 'connected') {
        const user = await FacebookAPI.me();
        commit('setSignupFlow', {
          type: SIGNUP_FLOW_TYPE_FACEBOOK,
          id: user.id,
          email: user.email,
          name: user.name
        });
        commit('updateField', { type: 'email', value: user.email });
        commit('updateField', { type: 'firstname', value: user.name });
      }
    },
    async register({ state, commit }, { loc }) {
      commit('increaseRequests');
      commit('setError', false);
      try {
        commit('setError', false);
        commit('setBadParams', false);
        commit('decreaseRequests');
        // const formData = new FormData(state.form);
        // // Make sure the password field is always present, even if it's an empty string, even for facebook login ( needed for api )
        // let password = formData.get('password');
        // password = (password || '').trim();
        // if (password === '') {
        //     formData.append('password', '');
        // }
        // formData.append('account_type', state.signupFlow.type);
        // formData.append('social_network_id', state.signupFlow.id);
        return await register(state.signupFlow, loc);
      } catch (e) {
        if (e instanceof ApiInvalidParamError) {
          commit('setBadParams', true);
          commit('setFieldsErrors', e.badParams);
        } else if (e instanceof ApiFatalError) {
          console.error('Register fatal error', e.response);
          commit('setError', true);
        } else {
          console.error('Register other fatal error', e.response);
          commit('setError', true);
        }
        commit('decreaseRequests');
        throw e;
      }
    }
  }
};

export default signup;
